/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdDomainSettingsPresentationOptions } from './FxIdDomainSettingsPresentationOptions';
import {
    instanceOfFxIdDomainSettingsPresentationOptions,
    FxIdDomainSettingsPresentationOptionsFromJSON,
    FxIdDomainSettingsPresentationOptionsFromJSONTyped,
    FxIdDomainSettingsPresentationOptionsToJSON,
} from './FxIdDomainSettingsPresentationOptions';

/**
 * @type FxIdApplicationPublicDataBuilderPublicDataBasePresentation
 * 
 * @export
 */
export type FxIdApplicationPublicDataBuilderPublicDataBasePresentation = FxIdDomainSettingsPresentationOptions;

export function FxIdApplicationPublicDataBuilderPublicDataBasePresentationFromJSON(json: any): FxIdApplicationPublicDataBuilderPublicDataBasePresentation {
    return FxIdApplicationPublicDataBuilderPublicDataBasePresentationFromJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPublicDataBasePresentationFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationPublicDataBuilderPublicDataBasePresentation {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsPresentationOptions(json)) {
        return FxIdDomainSettingsPresentationOptionsFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdApplicationPublicDataBuilderPublicDataBasePresentationToJSON(json: any): any {
    return FxIdApplicationPublicDataBuilderPublicDataBasePresentationToJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPublicDataBasePresentationToJSONTyped(value?: FxIdApplicationPublicDataBuilderPublicDataBasePresentation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdDomainSettingsPresentationOptions(value)) {
        return FxIdDomainSettingsPresentationOptionsToJSON(value as FxIdDomainSettingsPresentationOptions);
    }

    return {};
}

